// extracted by mini-css-extract-plugin
module.exports = {"header":"PrintHeader_header__1S1Wp","logo":"PrintHeader_logo__34I1L","title":"PrintHeader_title__1sX2u","description":"PrintHeader_description__3xFYy"};